import { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import { useStaticQuery, graphql } from 'gatsby';

import Container from '../../../Core/Container';
import BlogPostTiles from '../../../Custom/Blog/BlogPostTiles';
import Pagination from '../../../Core/Pagination';
import { BlogCards } from '../../../Custom/Card-Sections/BlogCards';

import { BlogPostGrid, PostsContainer, PaginationWrapper } from './styles';

const BlogScreen = ({ data }) => {
  const intl = useIntl();
  const [currentPage, setCurrentPage] = useState(1);

  const allArticles = useStaticQuery(query);

  const localeArticles = useMemo(
    () => (intl.locale === 'en' ? allArticles.en.nodes : allArticles.fr.nodes),
    [intl.locale],
  );

  // Sort blog posts so that posts that are missing the publish date
  // are pushed to the end of the list
  const sortedBlogPosts = localeArticles.sort((a, b) => {
    if (a.publishDate === b.publishDate) {
      return 0;
    }
    // nulls sort after anything else
    else if (a.publishDate === null) {
      return 1;
    } else if (b.publishDate === null) {
      return -1;
    }
    return 0;
  });

  const blogLength = localeArticles.length;

  return (
    <>
      <Container>
        <BlogPostGrid>
          <PostsContainer>
            <BlogPostTiles
              data={sortedBlogPosts}
              currentPage={currentPage}
              totalArticle={blogLength}
            />
            <PaginationWrapper>
              <Pagination
                totalArticle={blogLength}
                articlesPerPage={7}
                currentPage={currentPage}
                paginate={setCurrentPage}
              />
            </PaginationWrapper>
          </PostsContainer>
        </BlogPostGrid>
        <BlogCards data={data} className="inner-container" />
      </Container>
    </>
  );
};

BlogScreen.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default BlogScreen;

const query = graphql`
  query BlogScreenArticlesQuery {
    en: allContentfulArticles(
      sort: { publishDate: DESC }
      filter: {
        node_locale: { eq: "en-CA" }
        contentful_id: { nin: "NzWC96F3UrWflGeHGnYlC" }
        articleType: { eq: "blog" }
      }
    ) {
      nodes {
        ...blog_post_fragment
      }
    }
    fr: allContentfulArticles(
      sort: { publishDate: DESC }
      filter: {
        node_locale: { eq: "fr-CA" }
        contentful_id: { nin: "NzWC96F3UrWflGeHGnYlC" }
        articleType: { eq: "blog" }
        showFrench: { eq: true }
      }
    ) {
      nodes {
        ...blog_post_fragment
      }
    }
  }
`;
